import * as actionTypes from './actionTypes';
import { validInputs } from './constants';

interface State {
  data: any;
}

const initialState: State = {
  data: {}
}

export const extracharge = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.SET_EXTRACHARGE_ALL:
      return {
        ...state,
        data: {
          ...action.data
        }
      }
    case actionTypes.SET_EXTRACHARGE:
      return {
        ...state,
        data: {
          ...state.data,
          [action.id] : {
            ...state.data[action.id],
            data: action.data
          }
        }
      }
    case actionTypes.SELECT_EXTRACHARGE:
      const currentData = state.data[action.id];
      const itemClicked = currentData && currentData.data && currentData.data[action.index];
      const newData = currentData && currentData.data && currentData.data.map((item, index) => {
        const isShouldDisabled = validInputs(itemClicked, item);
        if (index === action.index) {
          return ({
            ...item,
            checked: action.isActive
          })
        }
        if (isShouldDisabled) {
          return ({
            ...item,
            disabled: action.isActive,
            checked: false
          })
        }
        return ({...item})
      });
      return {
        ...state,
        data: {
          ...state.data,
          [action.id]: {
            ...state.data[action.id],
            data : newData
          }
        }
      }
    case actionTypes.CLEAR_EXTRACHARGE_ALL:
      const list = state.data;
      const current = {};
      if (list && Object.keys(list).length > 0) {
        Object.keys(list).map(id => {
          const extraByChannel = list[id] && list[id].data;
          const cleanArr = extraByChannel && extraByChannel.map((item) => {
            return ({
              ...item,
              disabled: false,
              checked: false
            })
          });
          current[id] = {
            ...list[id],
            data: cleanArr
          }
        })
      }
      return {
        ...state,
        data: {...current}
      }
    case actionTypes.CLEAR_EXTRACHARGE:
      const charges = state.data;
      const formatted = charges && charges[action.id].data && charges[action.id].data.map(item => ({
        ...item,
        disabled: false,
        checked: false
      }));
      return {
        ...state,
        data: {
          ...state.data,
          [action.id]: {
            ...state.data[action.id],
            data: formatted
          }
        }
      }
    case actionTypes.SET_VIGNETTE_VALUE:
      return {
        ...state,
        data: {
          ...state.data,
          [action.id]: {
            ...state.data[action.id],
            vignette: action.value
          }
        }
      }
    case actionTypes.CLEAR_VIGNETTE_VALUE:
      return {
        ...state,
        data: {
          ...state.data,
          [action.id]: {
            ...state.data[action.id],
            vignette: null
          }
        }
      }
    default:
      return state;
  }
}
